"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDashboardThemeModifier = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
/**
 * Default modifier applied to any theme passed to DashboardView
 * @param theme - theme to modify
 * @beta
 * @deprecated Will be removed in the 8.10.0 release. Superseded by Dashboard component; please see `@gooddata/sdk-ui-dashboard` and GoodData.UI documentation for v8.7
 */
exports.defaultDashboardThemeModifier = function (theme) {
    var _a, _b, _c;
    if ((_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.dashboards) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.kpiWidget) === null || _c === void 0 ? void 0 : _c.kpi) {
        // duplicate dashboard specific kpi customization to the generic kpi key
        var themeWithKpi = cloneDeep_1.default(theme);
        themeWithKpi.kpi = tslib_1.__assign({}, theme.dashboards.content.kpiWidget.kpi);
        return themeWithKpi;
    }
    return theme;
};
//# sourceMappingURL=defaultDashboardThemeModifier.js.map